import { render } from "./DiskonModal_c.vue?vue&type=template&id=72c4db2b&scoped=true"
import script from "./DiskonModal_c.vue?vue&type=script&lang=js"
export * from "./DiskonModal_c.vue?vue&type=script&lang=js"

import "./DiskonModal_c.vue?vue&type=style&index=0&id=72c4db2b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72c4db2b"

export default script